export const UPLOAD_EQUIPMENT_FILE = 'UPLOAD_EQUIPMENT_FILE';
export const UPLOAD_EQUIPMENT_FILE_SUCCESS = 'UPLOAD_EQUIPMENT_FILE_SUCCESS';
export const UPLOAD_EQUIPMENT_FILE_FAILURE = 'UPLOAD_EQUIPMENT_FILE_FAILURE';

export const COPY_CHECKS = 'COPY_CHECKS';
export const COPY_CHECKS_SUCCESS = 'COPY_CHECKS_SUCCESS';
export const COPY_CHECKS_FAILURE = 'COPY_CHECKS_FAILURE';
